// @flow

import { type CheckoutReceipts, type Receipt } from './types';

export function getCryptocurrencyReceipt(receipts: CheckoutReceipts): ?Receipt {
  return receipts?.cryptocurrency;
}
